<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Order Accepted List</h2>
        </div>   

           <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                <!-- Start Date -->
                <div class="w-full lg:w-auto">
                    <label for="startDate" class="block text-sm font-medium text-gray-700 ">From Date</label>
                    <input
                        type="date"
                        id="startDate"
                        v-model="filter.startDate"
                        class="w-full p-2 border border-gray-300 rounded "
                    />
                </div>

                <!-- End Date -->
                <div class="w-full lg:w-auto">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">To Date</label>
                    <input type="date"
                        id="endDate"
                        v-model="filter.endDate"
                        class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded "
                    />
                </div>
                <div class="w-full lg:w-auto">
                    <label for="status" class="block text-sm font-medium text-gray-700">Status</label>
                    <select id="status"
                        v-model="filter.status"
                        class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded"
                    >
                        <option value="1">Processing</option>
                        <option value="2">Complete</option>
                    </select>
                </div>





                <!-- Filter Button -->
                <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                    <button
                        type="submit"
                        @click="getFilter"
                        class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                    >
                        Filter
                    </button>
                </div>
            </div>
       
        
        <div class="grid grid-cols-12">
            
           
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                   <div class="grid grid-cols-3 gap-4">
                    <div v-for="(item, index) in OrderTakenSaleList" :key="item.id" class="bg-white dark:bg-gray-800 shadow-md rounded-xl p-4 border border-gray-200 dark:border-gray-700">
                        <div class="text-lg font-semibold text-gray-800 dark:text-white">

                            Order No: {{ item.saleid }} (
                                {{
                                    item.markstatus == 0
                                    ? 'Pending'
                                    : item.markstatus == 1
                                    ? 'Processing'
                                    : item.markstatus == 2
                                    ? 'Complete'
                                    : 'Unknown'
                                }}
                                )

                        </div>
                          <!-- <span class="text-danger">
                                Delivery Date: {{ item.delivery || 0}}
                          </span> -->
                        <div class="mt-3 flex items-center justify-end">
                            <button class="btn-icon btn-primary-icon-light size-7" @click="print_measurement(item.id)">
                <i class="ri-check-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                </button>&nbsp;


                             

                        </div>
                    </div>
                    </div>

                        <div class="pt-4 text-right font-semibold text-gray-700 dark:text-white border-t border-gray-200 dark:border-gray-700">
                            Total Orders: {{ OrderTakenSaleList.length }}
                        </div>

                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'SaleList',
components: {
 
} ,
mounted(){

    if (this.$route.query.q) {
           this.getBasics(this.$route.query.q);
    }else{
       this.getBasics();
    }

},
computed: {

},
data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     items:[],

     endDate: today,
     OrderTakenSaleList:[],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
     Final:{total:0,paid:0,payable:0,disc:0},

     filter:{
        startDate:this.getStartDate(),
        endDate:today,
        status:'',
     }
 }
 }, 
methods:{
   

     
                       
 async getBasics(id) {
       var self=this;
         axios.post('gettailororderlist',{id:id}).then(function (response) {
              
                 self.OrderTakenSaleList=response.data.OrderTakenSaleList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
            
         
                    }); 
  }, 

          

  print_measurement(id)
        {
             
               // window.open('/print?q='+id, '_blank');
              //  window.open('/MeasurementDetails?q='+id, '_blank'); 
             this.$router.push({ path: '/MeasurementDetails', query: { q: id } });

        },

  getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },


     async getFilter() {
       var self=this;
         axios.post('getFilterTailorOrderlist',self.filter).then(function (response) {
              
                 self.OrderTakenSaleList=response.data.OrderTakenSaleList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
            
         
                    }); 
  },
                      





}
}
</script>
